import React, { useCallback } from 'react';
import { Textarea } from '@gafe/common-ui';

import { useOrderDispatch } from '@/components/modals/SubmitOrder/helpers';

import { OrderBlockWrapper } from '../../../Common/OrderBlockWrapper';

import { Props } from './types';

import styles from './PurchaseOrderNumber.module.scss';

export const PurchaseOrderNumber = ({ purchaseNumber }: Props) => {
  const dispatch = useOrderDispatch();
  const onChangeAlphaNumericInput = useCallback(
    (value: string) => {
      const regexp = /[^0-9a-z_@./#&+\-\s!$%^()*]+/gi;
      const $value = value?.replace(regexp, '');

      dispatch({
        type: 'UPDATE_ORDER',
        payload: {
          purchaseNumber: $value,
        },
      });
    },
    [dispatch],
  );

  return (
    <OrderBlockWrapper className={styles.purchase_number_order_block_wrapper} color="#f2f5f7">
      <div className={styles.purchase_number_wrapper}>
        <div className={styles.purchase_number_title}>
          <div className={styles.purchase_number_label}>Add Purchase Order Number</div>
          <span className={styles.purchase_number_optional}>(optional)</span>
        </div>
        <div className={styles.purchase_number_input}>
          <Textarea
            maxlength={255}
            name="purchaseOrderNumber"
            onChange={onChangeAlphaNumericInput}
            rows={1}
            testId="textarea-input"
            value={purchaseNumber ?? ''}
          />
        </div>
      </div>
    </OrderBlockWrapper>
  );
};
